<template>
    <edit></edit>
</template>

<script>
    import edit from './special_price_edit.vue'

    export default {
        name: 'special_price_add',

        components: {
            edit
        }
    }
</script>